import { useDashboardSurveyList } from "./useDashboardSurveyList";
import { DASHBOARD_SURVEY_LIST_PAGE_SIZE } from "./dashboard-survey-list.constants";
import SurveyCard from "./survey-card.component";
import { Survey } from "../../../redux/survey/survey.types";
import { constant, times } from "lodash";
import DashboardSurveyFilter from "./dashboard-survey-filter.component";
import DashboardSurveyPagination from "./dashboard-survey-pagination.component";
import DashboardSurveyListEmpty from "./dashboard-survey-list-empty.component";

const DashboardSurveyList = () => {
  const { data, isFetching } = useDashboardSurveyList();
  const surveys = data?.surveys ?? [];
  const loadingArray = times(DASHBOARD_SURVEY_LIST_PAGE_SIZE, constant(undefined));
  const isEmpty = data?.totalObjects === 0;

  const renderCards = (surveys: (Survey | undefined)[]) => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full" >
        {surveys.map((survey, index) => (
          <SurveyCard
            survey={survey}
            key={`survey-card-${index}`}
            index={index}
          />
        ))}
      </div>
    );
  };

  return (
    <div
      className="flex flex-col gap-6 grow"
      id="survey-list"
    >
      <DashboardSurveyFilter />
      {isEmpty ? <DashboardSurveyListEmpty /> : renderCards(isFetching ? loadingArray : surveys)}
      <DashboardSurveyPagination />
    </div>
  );
};

export default DashboardSurveyList;
